import React, { PropsWithChildren, useContext, useState } from 'react';
import { useAsyncCallback, UseAsyncReturn } from 'react-async-hook';
import { connectApiAxios } from '../config/axios';
import Cookies from "universal-cookie";

type DocumentsContextProps = {

  getDocuments: UseAsyncReturn<any, [companyId: string]>;
  getDocumentsByType: UseAsyncReturn<any, [companyId: string, type: string]>;
  uploadDocument: UseAsyncReturn<any, [companyId: string, file: File, documentType: string]>;
  deleteDocument: UseAsyncReturn<any, [companyId: string, type: string]>;
  documentLoading: boolean;
  setDocumentLoading: (val: boolean) => void;

};

const DocumentsContext = React.createContext<DocumentsContextProps>({} as any);

const DocumentsContextProvider: React.FC<PropsWithChildren<any>> = ( props ) => {
  const { children } = props;

  const cookies = new Cookies();
  const token = cookies.get('jwt_authorization');
  const [documentLoading, setDocumentLoading] = useState<boolean>(false);

  const getDocuments = useAsyncCallback(async ( companyId ) => {
    const jwt_authorization = cookies.get('jwt_authorization');

    const { data } = await connectApiAxios.get<any>(
      `/api/company/${companyId}/documents`,
      {
        headers: {
          authorization: `Bearer ${jwt_authorization}`,
        }
      }
    );

    return data;
  });

  const getDocumentsByType = useAsyncCallback(async ( companyId, type ) => {

    const { data } = await connectApiAxios.get<any>(
      `/api/company/${companyId}/documents/${type}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        }
      }
    );

    return data;
  });

  const uploadDocument = useAsyncCallback(async ( companyId, file: File, documentType: string ) => {

    const body: any = new FormData();
    body.append('file', file);
      const { data } = await connectApiAxios.post<any>(
        `/api/company/${companyId}/documents?documentType=${documentType}`,
        body,
        {
          headers: {
            authorization: `Bearer ${token}`,
          }
        }
      );
      return data;

  });

  const deleteDocument = useAsyncCallback(async ( companyId, documentType: string ) => {

    const { data } = await connectApiAxios.delete<any>(
      `/api/company/${companyId}/documents?documentType=${documentType}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        }
      }
    );

    return data;
  });



  return (
    <DocumentsContext.Provider
      value={{
        getDocuments,
        getDocumentsByType,
        uploadDocument,
        deleteDocument,
        documentLoading,
        setDocumentLoading
      }}
    >
      {children}
    </DocumentsContext.Provider>
  );
};

export const useDocuments = () => useContext(DocumentsContext);

export default DocumentsContextProvider;
